/**
 * 将订单地址中的电话号码规范化为 E.164 格式（+国家码+号码），用于第三方平台用户识别。
 * 约定与 facebookProvider/snapchatProvider 一致：telephone 存本地号码、tel_code 存国家码，始终拼接。
 * telephone 已带 + 前缀时视为国际格式，仅清理格式字符；缺少 tel_code 时无法确定国家码，原样返回。
 */
export function toE164Phone(telCode?: string, telephone?: string): string {
  if (!telephone) return telephone ?? '';
  const digits = telephone.replace(/\D/g, '');
  if (!digits) return telephone;
  if (telephone.trim().startsWith('+')) return `+${digits}`;
  const code = telCode?.replace(/\D/g, '');
  if (!code) return telephone;
  return `+${code}${digits}`;
}
